import { Outlet } from "react-router";

import { LegalFooter } from "~/shared/components/legal-footer/legal-footer.tsx";
import { PublicLayout } from "~/shared/components/public-layout/public-layout.tsx";

import * as styles from "./sidebar-layout.module.css";

/**
 * Route-level layout for pages that display the Cincinnati skyline sidebar
 * instead of the navigation sidebar. Used for the 404 and track-shipment
 * routes in both authenticated and public routers.
 */
export function SidebarLayout() {
	return (
		<PublicLayout>
			<div className={styles.container}>
				<div className={styles.content}>
					<Outlet />
				</div>
				<LegalFooter />
			</div>
		</PublicLayout>
	);
}
